import processClient from '.'
import { getAuthHeaders } from 'utils/requests'
import { cacheClear } from 'utils/memoryCache'

const setCommentsProcess = async (id, coments) => {
  const headers = { headers: getAuthHeaders() }
  
  const response = await processClient.patch(`/save/${id}`, { Comentario: JSON.stringify(coments) }, headers)
  cacheClear('processes:')
  return response
}

export default setCommentsProcess

